"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7226],{

/***/ 45638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Buttons; },
/* harmony export */   "V": function() { return /* binding */ Content; }
/* harmony export */ });
/* harmony import */ var _styles_stitches__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42441);

var Content = (0,_styles_stitches__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxHeight: "60vh",
    overflow: "hidden",
    overflowY: "auto",
    "@bp1": {
        height: "unset",
        maxHeight: "50vh"
    }
});
var Buttons = (0,_styles_stitches__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    "& > *": {
        marginTop: "$space$4"
    }
});


/***/ }),

/***/ 78870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Upload; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/buffer/index.js
var node_modules_buffer = __webpack_require__(48764);
// EXTERNAL MODULE: ./node_modules/uppie/uppie.js
var uppie_uppie = __webpack_require__(66937);
var uppie_default = /*#__PURE__*/__webpack_require__.n(uppie_uppie);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/lib/media/common.ts
var common = __webpack_require__(8065);
// EXTERNAL MODULE: ./src/utils/file.ts
var utils_file = __webpack_require__(12111);
;// CONCATENATED MODULE: ./src/utils/mime-type.ts
/* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var getMimeType = function(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onloadend = function(e) {
            if (e.target && e.target.readyState === FileReader.DONE) {
                var uint = new Uint8Array(e.target.result);
                var bytes = [];
                uint.forEach(function(byte) {
                    bytes.push(byte.toString(16));
                });
                var hex = bytes.join("").toUpperCase();
                var mimeType;
                switch(hex){
                    case "676C5446":
                        mimeType = constants/* MimeType.GLB */.HY.GLB;
                        break;
                    default:
                        mimeType = "Unknown MimeType";
                }
                resolve(mimeType);
            }
        };
        reader.onerror = function() {
            return resolve("Unknown MimeType");
        };
        reader.readAsArrayBuffer(file.slice(0, 4));
    });
};

// EXTERNAL MODULE: ./node_modules/svg-parser/dist/svg-parser.esm.js
var svg_parser_esm = __webpack_require__(61212);
;// CONCATENATED MODULE: ./src/utils/svg.ts


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var hasViewBox = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function(event) {
                            var ref;
                            var text = (ref = event.target) === null || ref === void 0 ? void 0 : ref.result;
                            if (!text || typeof text !== "string") reject();
                            var parsed = (0,svg_parser_esm/* parse */.Q)(text);
                            var svg = parsed.children.find(function(child) {
                                return child.tagName === "svg";
                            });
                            if (!svg.properties.viewBox) return resolve(false);
                            var parts = svg.properties.viewBox.split(" ");
                            if (parts.length !== 4) return resolve(false);
                            return resolve(true);
                        };
                        reader.onerror = function(event) {
                            reject(event);
                        };
                        reader.readAsText(file);
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hasViewBox(file) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/utils/web.ts



/* eslint-disable no-await-in-loop */ function getFilename(path) {
    var parts = path.split("/");
    return parts[parts.length - 1];
}
function injectCSPMetaTagIntoHTML(html) {
    // HTML -> doc
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    // remove any existing CSP meta tags
    var existing = doc.head.querySelectorAll('meta[http-equiv="Content-Security-Policy"]');
    if (existing.length) {
        for(var i = 0; i < existing.length; i += 1){
            existing[i].remove();
        }
    }
    if (!doc.head) {
        throw new Error("index.html is missing <head> tag!");
    }
    // inject CSP meta tag
    doc.head.insertAdjacentHTML("afterbegin", "\n    <meta http-equiv=\"Content-Security-Policy\" content=\"\n    upgrade-insecure-requests;\n    default-src\n      'none';\n    frame-src\n      'self';\n    child-src\n      'self'\n      blob:;\n    script-src\n      'self'\n      'unsafe-inline'\n      'unsafe-eval'\n      blob:;\n    style-src\n      'self'\n      'unsafe-inline';\n    img-src\n      'self'\n      'unsafe-inline'\n      data:\n      blob:\n      https://services.tzkt.io\n      https://ipfs.infura.io\n      https://*.infura-ipfs.io\n      https://cloudflare-ipfs.com/\n      https://ipfs.io/\n      https://templewallet.com/logo.png\n      https://gateway.pinata.cloud/;\n    font-src\n      'self'\n      data:\n      https://ipfs.infura.io\n      https://*.infura-ipfs.io\n      https://cloudflare-ipfs.com/\n      https://fonts.googleapis.com/\n      https://ipfs.io/\n      https://gateway.pinata.cloud/;\n    connect-src\n      'self'\n      https://better-call.dev\n      https://*.better-call.dev\n      https://*.cryptonomic-infra.tech\n      https://cryptonomic-infra.tech\n      https://*.infura.io\n      https://*.infura-ipfs.io\n      https://infura.io\n      blob:\n      data:\n      ws:\n      wss:\n      bootstrap.libp2p.io\n      preload.ipfs.io\n      https://api.versum.xyz\n      https://mainnet.smartpy.io\n      https://mainnet-tezos.giganode.io\n      https://api.etherscan.io\n      https://api.thegraph.com\n      https://*.tzkt.io\n      https://api.hicdex.com\n	    https://hdapi.teztools.io\n      https://api.tzstats.com\n      https://*.wikidata.org\n      https://*.coinmarketcap.com\n      https://api.openweathermap.org\n      https://hicetnunc.xyz\n      https://*.hicetnunc.xyz\n      https://api.teztok.com;\n    manifest-src\n      'self';\n    base-uri\n      'self';\n    form-action\n      'none';\n    media-src\n      'self'\n      'unsafe-inline'\n      data:\n      blob:\n      https://ipfs.infura.io\n      https://*.infura-ipfs.io\n      https://cloudflare-ipfs.com/\n      https://ipfs.io/\n      https://gateway.pinata.cloud/;\n    prefetch-src\n      'self'\n      https://ipfs.infura.io\n      https://*.infura-ipfs.io\n      https://cloudflare-ipfs.com/\n      https://fonts.googleapis.com/\n      https://ipfs.io/\n      https://gateway.pinata.cloud/;\n    worker-src\n      'self'\n      'unsafe-inline'\n      blob:;\">\n  ");
    // doc -> HTML
    return "<!DOCTYPE html><html>".concat(doc.documentElement.innerHTML, "</html>");
}
function injectCSPMetaTagIntoBuffer(buffer) {
    var html = new TextDecoder().decode(buffer);
    var safeHTML = injectCSPMetaTagIntoHTML(html);
    return new TextEncoder().encode(safeHTML);
}
function validateWebDirectoryFiles(files) {
    return _validateWebDirectoryFiles.apply(this, arguments);
}
function _validateWebDirectoryFiles() {
    _validateWebDirectoryFiles = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(files) {
        var pageBlob, htmlString, parser, doc;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (files["index.html"]) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        valid: false,
                        error: "Missing index.html file"
                    });
                case 2:
                    pageBlob = files["index.html"];
                    _ctx.next = 5;
                    return pageBlob.text();
                case 5:
                    htmlString = _ctx.sent;
                    parser = new DOMParser();
                    doc = parser.parseFromString(htmlString, "text/html");
                    if (doc.head) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        valid: false,
                        error: "Missing <head> tag in index.html"
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        valid: true
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _validateWebDirectoryFiles.apply(this, arguments);
}
function prepareWebDirectory(files) {
    return _prepareWebDirectory.apply(this, arguments);
}
function _prepareWebDirectory() {
    _prepareWebDirectory = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(files) {
        var entries, rootDir, i, parts, filename, partsClone, outFiles, indexBlob, k, pageBuffer, safePageBuffer, filename1, check;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    entries = Object.entries(files);
                    rootDir = null;
                    i = 0;
                case 3:
                    if (!(i < entries.length)) {
                        _ctx.next = 14;
                        break;
                    }
                    parts = entries[i][0].split("/");
                    filename = parts[parts.length - 1].toLowerCase();
                    if (!(filename === "index.html")) {
                        _ctx.next = 11;
                        break;
                    }
                    partsClone = parts.slice();
                    partsClone.pop();
                    rootDir = partsClone.join("/");
                    return _ctx.abrupt("break", 14);
                case 11:
                    i += 1;
                    _ctx.next = 3;
                    break;
                case 14:
                    if (!(rootDir === null)) {
                        _ctx.next = 16;
                        break;
                    }
                    throw new Error("No index.html file found!");
                case 16:
                    outFiles = {};
                    entries.forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), path = _param[0], file = _param[1];
                        var relPath = path.replace("".concat(rootDir, "/"), "");
                        var filename = getFilename(relPath);
                        outFiles[relPath] = new File([
                            file
                        ], filename, {
                            type: file.type
                        });
                    });
                    indexBlob = outFiles["index.html"];
                    _ctx.t0 = runtime_default().keys(outFiles);
                case 20:
                    if ((_ctx.t1 = _ctx.t0()).done) {
                        _ctx.next = 33;
                        break;
                    }
                    k = _ctx.t1.value;
                    if (!(k.endsWith(".html") || k.endsWith(".htm"))) {
                        _ctx.next = 31;
                        break;
                    }
                    _ctx.t2 = Uint8Array;
                    _ctx.next = 26;
                    return outFiles[k].arrayBuffer();
                case 26:
                    _ctx.t3 = _ctx.sent;
                    pageBuffer = new _ctx.t2(_ctx.t3);
                    safePageBuffer = injectCSPMetaTagIntoBuffer(pageBuffer);
                    filename1 = getFilename(k);
                    outFiles[k] = new File([
                        safePageBuffer
                    ], filename1, {
                        type: indexBlob.type
                    });
                case 31:
                    _ctx.next = 20;
                    break;
                case 33:
                    _ctx.next = 35;
                    return validateWebDirectoryFiles(outFiles);
                case 35:
                    check = _ctx.sent;
                    if (check.valid) {
                        _ctx.next = 38;
                        break;
                    }
                    throw new Error(check.error);
                case 38:
                    return _ctx.abrupt("return", outFiles);
                case 39:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _prepareWebDirectory.apply(this, arguments);
}
function getCoverImagePathFromDoc(doc) {
    var meta = doc.head.querySelector('meta[property="cover-image"]');
    if (!meta) {
        meta = doc.head.querySelector('meta[property="og:image"]');
    }
    if (!meta) return null;
    return meta.getAttribute("content");
}
function injectCSPMetaTagIntoDataURI(dataURI) {
    // data URI -> HTML
    var prefix = "data:text/html;base64,";
    var base64 = dataURI.replace(prefix, "");
    var html = atob(base64);
    // inject CSP meta tag
    var safeHTML = injectCSPMetaTagIntoHTML(html);
    // HTML -> data URI
    return "".concat(prefix).concat(btoa(safeHTML));
}
function getCoverImagePathFromBuffer(buffer) {
    // buffer -> html
    var html = new TextDecoder().decode(buffer);
    // html -> doc
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    return getCoverImagePathFromDoc(doc);
}

// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/upload/styles.tsx

var Label = (0,stitches/* styled */.zo)("label", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "$secondaryBackground",
    color: "$secondaryFill",
    width: "100%",
    height: 120,
    borderRadius: 5,
    fontSize: 14,
    cursor: "copy",
    i: {
        color: "inherit",
        fontWeight: "normal"
    },
    "&:hover": {
        color: "$primaryFill"
    },
    variants: {
        hover: {
            true: {
                border: "1px solid $colors$primaryFill"
            }
        }
    }
});
var Subtext = (0,stitches/* styled */.zo)("div", {
    paddingTop: "$space$4",
    fontSize: 12,
    color: "$primaryFill"
});
var Input = (0,stitches/* styled */.zo)("input", {});

;// CONCATENATED MODULE: ./src/components/upload/index.tsx





/* eslint-disable no-alert */ 









var Upload = function(param) {
    var _onChange = param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, restrict = param.restrict, _directories = param.directories, directories = _directories === void 0 ? false : _directories, _useFallbackImageMaxSize = param.useFallbackImageMaxSize, useFallbackImageMaxSize = _useFallbackImageMaxSize === void 0 ? false : _useFallbackImageMaxSize;
    var ref = (0,react.useState)(false), hover = ref[0], setHover = ref[1];
    var ref1 = (0,react.useState)("Choose a ".concat(directories ? "directory" : "file", " or drag it here")), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,react.useState)(), originalAsset = ref2[0], setOriginalAsset = ref2[1];
    var uploadWrapper = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleAsDirectory = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(asset) {
                var webDirectory;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setMessage("web directory");
                            _ctx.next = 3;
                            return prepareWebDirectory(asset);
                        case 3:
                            webDirectory = _ctx.sent;
                            onChange({
                                name: "",
                                mimeType: constants/* MimeType.WEB */.HY.WEB,
                                asset: webDirectory
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleAsDirectory(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleAsFile = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(asset) {
                var buffer, reader;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setMessage(asset.name);
                            _ctx.t0 = node_modules_buffer.Buffer;
                            _ctx.next = 4;
                            return asset.arrayBuffer();
                        case 4:
                            _ctx.t1 = _ctx.sent;
                            buffer = _ctx.t0.from.call(_ctx.t0, _ctx.t1);
                            reader = new FileReader();
                            reader.addEventListener("load", function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ev) {
                                    var uri, blobUrl, mimeType, dimensions;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                uri = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
                                                ;
                                                if (ev.target) {
                                                    uri = ev.target.result;
                                                    blobUrl = URL.createObjectURL(asset);
                                                }
                                                if (!(asset.type !== "")) {
                                                    _ctx.next = 7;
                                                    break;
                                                }
                                                _ctx.t0 = asset.type;
                                                _ctx.next = 10;
                                                break;
                                            case 7:
                                                _ctx.next = 9;
                                                return getMimeType(asset);
                                            case 9:
                                                _ctx.t0 = _ctx.sent;
                                            case 10:
                                                mimeType = _ctx.t0;
                                                ;
                                                _ctx.t1 = mimeType;
                                                _ctx.next = _ctx.t1 === constants/* MimeType.PNG */.HY.PNG ? 15 : _ctx.t1 === constants/* MimeType.JPEG */.HY.JPEG ? 15 : _ctx.t1 === constants/* MimeType.GIF */.HY.GIF ? 15 : _ctx.t1 === constants/* MimeType.MP4 */.HY.MP4 ? 19 : _ctx.t1 === constants/* MimeType.PDF */.HY.PDF ? 23 : 25;
                                                break;
                                            case 15:
                                                _ctx.next = 17;
                                                return (0,common/* getImageMetadata */.sw)(asset);
                                            case 17:
                                                dimensions = _ctx.sent;
                                                return _ctx.abrupt("break", 26);
                                            case 19:
                                                _ctx.next = 21;
                                                return (0,common/* getVideoMetadata */.cH)(asset);
                                            case 21:
                                                dimensions = _ctx.sent;
                                                return _ctx.abrupt("break", 26);
                                            case 23:
                                                dimensions = {
                                                    width: 595,
                                                    height: 842
                                                };
                                                return _ctx.abrupt("break", 26);
                                            case 25:
                                                dimensions = {
                                                    width: 100,
                                                    height: 100
                                                };
                                            case 26:
                                                onChange({
                                                    name: asset.name,
                                                    mimeType: mimeType,
                                                    asset: asset,
                                                    dimensions: dimensions,
                                                    buffer: buffer,
                                                    uri: uri,
                                                    blobUrl: blobUrl
                                                });
                                            case 27:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(ev) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            reader.readAsDataURL(asset);
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleAsFile(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var onUploadAsset = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(asset) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setOriginalAsset(asset);
                            if ((0,_instanceof/* default */.Z)(asset, File)) {
                                handleAsFile(asset);
                            } else {
                                handleAsDirectory(asset);
                            }
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function onUploadAsset(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleError = function(error) {
            // TODO: Implement proper error modal
            alert(error);
        };
        var uploadHandler = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_event, formData) {
                var fileList, directory, file, check;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(formData === undefined)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            fileList = Array.from(formData.values()).map(function(entry) {
                                return entry;
                            });
                            if (!directories) {
                                _ctx.next = 12;
                                break;
                            }
                            if ((0,utils_file/* validateCumulativeFileSize */.Ed)(fileList, constants/* MAX_UPLOAD_SIZE_MB */.yL)) {
                                _ctx.next = 7;
                                break;
                            }
                            handleError("Directory exceeds ".concat(constants/* MAX_UPLOAD_SIZE_MB */.yL, "MB limit"));
                            return _ctx.abrupt("return");
                        case 7:
                            directory = {};
                            fileList.forEach(function(file) {
                                directory[file.name] = file;
                            });
                            onUploadAsset(directory);
                            _ctx.next = 30;
                            break;
                        case 12:
                            file = fileList[0];
                            if (!(useFallbackImageMaxSize && file.type.startsWith("image"))) {
                                _ctx.next = 19;
                                break;
                            }
                            if ((0,utils_file/* validateCumulativeFileSize */.Ed)([
                                file
                            ], constants/* MAX_UPLOAD_SIZE_MB_IMAGE_FALLBACK */.ZE)) {
                                _ctx.next = 17;
                                break;
                            }
                            handleError("Your browser doesn't support some minting features, making the maximum image file size ".concat(constants/* MAX_UPLOAD_SIZE_MB_IMAGE_FALLBACK */.ZE, " MB instead of ").concat(constants/* MAX_UPLOAD_SIZE_MB */.yL, " MB. Please try a different browser, or consider reducing the file size."));
                            return _ctx.abrupt("return");
                        case 17:
                            _ctx.next = 22;
                            break;
                        case 19:
                            if ((0,utils_file/* validateCumulativeFileSize */.Ed)([
                                file
                            ], constants/* MAX_UPLOAD_SIZE_MB */.yL)) {
                                _ctx.next = 22;
                                break;
                            }
                            handleError("File exceeds ".concat(constants/* MAX_UPLOAD_SIZE_MB */.yL, "MB limit."));
                            return _ctx.abrupt("return");
                        case 22:
                            if (!(file.type === constants/* MimeType.SVG */.HY.SVG)) {
                                _ctx.next = 29;
                                break;
                            }
                            _ctx.next = 25;
                            return hasViewBox(file);
                        case 25:
                            check = _ctx.sent;
                            if (check) {
                                _ctx.next = 29;
                                break;
                            }
                            handleError("SVG file is missing required viewBox attribute.");
                            return _ctx.abrupt("return");
                        case 29:
                            onUploadAsset(fileList[0]);
                        case 30:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function uploadHandler(_event, formData) {
                return _ref.apply(this, arguments);
            };
        }();
        if (uploadWrapper.current === null) {
            return;
        }
        var uppie = new (uppie_default())();
        uppie(uploadWrapper.current, uploadHandler);
        uppie(uploadWrapper.current.querySelector('input[type="file"]'), uploadHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleDragOver = function(e) {
        e.preventDefault();
        setMessage("Drop here to upload");
        setHover(true);
    };
    var onDragLeave = function(e) {
        e.preventDefault();
        if (!originalAsset) {
            var entity = directories ? "directory" : "file";
            setMessage("Choose a ".concat(entity, " or drag it here"));
        } else {
            var name = directories ? "web directory" : originalAsset.name;
            setMessage(name);
        }
        setHover(false);
    };
    var extra = {
        hidden: true
    };
    var extraDir = {
        directory: "true",
        webkitdirectory: "true",
        mozdirectory: "true",
        msdirectory: "true",
        odirectory: "true",
        allowdirs: "true"
    };
    var supported = null;
    if (restrict && restrict.length) {
        extra.accept = restrict.join(",");
        var types = restrict.filter(function(r) {
            return r.startsWith(".");
        }).map(function(r) {
            return r.substring(1);
        });
        supported = "Supported: ".concat(types.join(", "));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: uploadWrapper,
        onDragOver: handleDragOver,
        onDragLeave: onDragLeave,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
            hover: hover,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "upload_file"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: message
                }),
                !originalAsset && !!supported && /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtext, {
                    children: supported
                }),
                directories ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                    id: "upload",
                    type: "file"
                }, extra, extraDir)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                    id: "upload",
                    type: "file"
                }, extra))
            ]
        })
    });
};


/***/ }),

/***/ 8065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": function() { return /* binding */ getGIFInfo; },
/* harmony export */   "RT": function() { return /* binding */ getExtension; },
/* harmony export */   "V6": function() { return /* binding */ isPowersOfTwo; },
/* harmony export */   "cH": function() { return /* binding */ getVideoMetadata; },
/* harmony export */   "hl": function() { return /* binding */ blobToFile; },
/* harmony export */   "sC": function() { return /* binding */ getValidSizes; },
/* harmony export */   "sw": function() { return /* binding */ getImageMetadata; },
/* harmony export */   "zI": function() { return /* binding */ getMediaMetadata; }
/* harmony export */ });
/* unused harmony export getAudioMetadata */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var gifuct_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75119);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);




var isPowersOfTwo = function(n) {
    return !(Math.pow(2, Math.ceil(Math.log2(n))) - n);
};
var getValidSizes = function(sizes, actual, ensureActualMin, ensureActualMax) {
    var valid = sizes.filter(function(size) {
        return size < actual;
    });
    if (ensureActualMax && valid[valid.length - 1] < actual) {
        valid.push(actual);
    }
    if (ensureActualMin && !valid.length) {
        valid.push(actual);
    }
    return valid;
};
var blobToFile = function(blob, fileName) {
    return new File([
        blob
    ], fileName, {
        lastModified: Date.now(),
        type: blob.type
    });
};
var getExtension = function(str) {
    return str.split(".").pop();
};
var getImageMetadata = function(blob) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            resolve({
                width: img.width,
                height: img.height
            });
        };
        img.onerror = function(err) {
            reject(err);
        };
        img.src = URL.createObjectURL(blob);
    });
};
var getGIFInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(blob) {
        var buff, gif, frames, delays, duration;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return blob.arrayBuffer();
                case 2:
                    buff = _ctx.sent;
                    _ctx.next = 5;
                    return (0,gifuct_js__WEBPACK_IMPORTED_MODULE_1__/* .parseGIF */ .vq)(buff);
                case 5:
                    gif = _ctx.sent;
                    _ctx.next = 8;
                    return (0,gifuct_js__WEBPACK_IMPORTED_MODULE_1__/* .decompressFrames */ .zw)(gif, true);
                case 8:
                    frames = _ctx.sent;
                    delays = frames.map(function(frame) {
                        return frame.delay;
                    });
                    duration = delays.reduce(function(v1, v2) {
                        return v1 + v2;
                    }) / 1000;
                    return _ctx.abrupt("return", {
                        frameCount: frames.length,
                        duration: duration,
                        width: gif.lsd.width,
                        height: gif.lsd.height
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGIFInfo(blob) {
        return _ref.apply(this, arguments);
    };
}();
var getAudioMetadata = function(blob) {
    return new Promise(function(resolve, reject) {
        var audio = document.createElement("audio");
        audio.addEventListener("loadedmetadata", function() {
            resolve({
                duration: audio.duration
            });
        }, false);
        audio.addEventListener("error", function(err) {
            reject(err);
        });
        audio.src = URL.createObjectURL(blob);
    });
};
var getVideoMetadata = function(blob) {
    return new Promise(function(resolve, reject) {
        var video = document.createElement("video");
        video.addEventListener("loadedmetadata", function() {
            resolve({
                width: video.videoWidth,
                height: video.videoHeight,
                duration: video.duration
            });
        }, false);
        video.addEventListener("error", function(err) {
            reject(err);
        });
        video.src = URL.createObjectURL(blob);
    });
};
var getMediaMetadata = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var meta;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!_constants__WEBPACK_IMPORTED_MODULE_2__/* .VIDEO_MIMETYPES.includes */ .ho.includes(file.type)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 4;
                    return getVideoMetadata(file);
                case 4:
                    meta = _ctx.sent;
                    _ctx.next = 20;
                    break;
                case 7:
                    if (!_constants__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_MIMETYPES.includes */ .E0.includes(file.type)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 10;
                    return getImageMetadata(file);
                case 10:
                    meta = _ctx.sent;
                    _ctx.next = 20;
                    break;
                case 13:
                    if (!_constants__WEBPACK_IMPORTED_MODULE_2__/* .AUDIO_MIMETYPES.includes */ .yz.includes(file.type)) {
                        _ctx.next = 19;
                        break;
                    }
                    _ctx.next = 16;
                    return getAudioMetadata(file);
                case 16:
                    meta = _ctx.sent;
                    _ctx.next = 20;
                    break;
                case 19:
                    {
                        meta = {};
                    }
                case 20:
                    return _ctx.abrupt("return", meta);
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMediaMetadata(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 46493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ PREVIEW_VIDEO_WIDTHS; },
/* harmony export */   "L8": function() { return /* binding */ FFMPEG_QUALITY_LEVEL; },
/* harmony export */   "Nq": function() { return /* binding */ PREVIEW_VIDEO_FILENAME_PREFIX; },
/* harmony export */   "UV": function() { return /* binding */ FULL_VIDEO_FILENAME_PREFIX; },
/* harmony export */   "Wc": function() { return /* binding */ PREVIEW_IMAGE_WIDTHS; },
/* harmony export */   "az": function() { return /* binding */ FULL_VIDEO_HEIGHTS_POW2; },
/* harmony export */   "h7": function() { return /* binding */ FULL_VIDEO_HEIGHTS_DEFAULT; },
/* harmony export */   "ks": function() { return /* binding */ PREVIEW_VIDEO_MAX_DURATION; },
/* harmony export */   "kx": function() { return /* binding */ ORIGINAL_FILENAME_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ PREVIEW_IMAGE_FILENAME_PREFIX; },
/* harmony export */   "qI": function() { return /* binding */ PREVIEW_VIDEO_SUBTITLES_PREFIX; },
/* harmony export */   "x8": function() { return /* binding */ FFMEPEG_WASM_ENABLED; }
/* harmony export */ });
var PREVIEW_IMAGE_WIDTHS = [
    480,
    960,
    1024,
    2048
];
var PREVIEW_VIDEO_WIDTHS = [
    480 /* , 960 */ 
];
var FULL_VIDEO_HEIGHTS_POW2 = [
    512 /* , 1024, 2048 */ 
];
var FULL_VIDEO_HEIGHTS_DEFAULT = [
    720 /* , 1080, 1440, 2160 */ 
];
var FFMPEG_QUALITY_LEVEL = 4;
var PREVIEW_VIDEO_MAX_DURATION = 20;
var PREVIEW_IMAGE_FILENAME_PREFIX = "preview_image_";
var PREVIEW_VIDEO_FILENAME_PREFIX = "preview_video_";
var PREVIEW_VIDEO_SUBTITLES_PREFIX = "subtitles_";
var ORIGINAL_FILENAME_PREFIX = "original_";
var FULL_VIDEO_FILENAME_PREFIX = "full_video_";
// uses ffmpeg or cloudinary
var FFMEPEG_WASM_ENABLED = true;


/***/ }),

/***/ 12111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ validateCumulativeFileSize; },
/* harmony export */   "M4": function() { return /* binding */ fileToDataURI; },
/* harmony export */   "tG": function() { return /* binding */ dataURIToBuffer; }
/* harmony export */ });
/* unused harmony exports getDataURIMimeType, dataURIToFile */
function validateCumulativeFileSize(files, maxMB) {
    var size = 0;
    for(var i = 0; i < files.length; i += 1){
        var file = files[i];
        if (file) {
            size += file.size;
        }
    }
    var maxBytes = maxMB * 1024 * 1024;
    return size <= maxBytes;
}
function dataURIToBuffer(uri) {
    var parts = uri.split(",");
    var base64 = parts[1];
    var binaryStr = atob(base64);
    var len = binaryStr.length;
    var bytes = new Uint8Array(len);
    for(var i = 0; i < len; i += 1){
        bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
}
function getDataURIMimeType(uri) {
    return uri.split(",")[0].split(":")[1].split(";")[0];
}
function dataURIToFile(uri, name, lastModified) {
    var buffer = dataURIToBuffer(uri);
    var type = getDataURIMimeType(uri);
    return new File([
        buffer
    ], name, {
        type: type,
        lastModified: lastModified
    });
}
function fileToDataURI(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            resolve(reader.result);
        }, false);
        reader.addEventListener("error", function(err) {
            reject(err);
        }, false);
        reader.readAsDataURL(file);
    });
}


/***/ }),

/***/ 80125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ getURLFromIPFSorHTTP; },
/* harmony export */   "NB": function() { return /* binding */ Node; },
/* harmony export */   "vR": function() { return /* binding */ getURLFromIPFSURI; }
/* harmony export */ });
/* unused harmony export ensureCIDv1 */
/* harmony import */ var multiformats_cid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81362);
/* eslint-disable no-console */ 
var Node;
(function(Node) {
    Node[Node["INFURA"] = 0] = "INFURA";
    Node[Node["CLOUDFLARE"] = 1] = "CLOUDFLARE";
    Node[Node["PINATA"] = 2] = "PINATA";
    Node[Node["IPFS"] = 3] = "IPFS";
    Node[Node["DWEB"] = 4] = "DWEB";
    Node[Node["VERSUM"] = 5] = "VERSUM";
})(Node || (Node = {}));
var ensureCIDv1 = function(cid) {
    if (cid === "") {
        console.warn("empty cid -----<");
        return "";
    }
    if (!cid.startsWith("baf")) {
        cid = multiformats_cid__WEBPACK_IMPORTED_MODULE_0__/* .CID.parse */ .k.parse(cid).toV1().toString();
    }
    return cid;
};
var getURLFromIPFSURI = function(uri) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.IPFS;
    var parts = uri.replace("ipfs://", "").split("/");
    var cid = parts[0];
    var cidv1 = ensureCIDv1(cid);
    var path = parts.length ? "/".concat(parts.slice(1).join("/")) : "";
    switch(type){
        case Node.CLOUDFLARE:
            return "https://cloudflare-ipfs.com/ipfs/".concat(cidv1).concat(path);
        case Node.INFURA:
            return "https://".concat(cidv1, ".ipfs.infura-ipfs.io").concat(path);
        case Node.PINATA:
            return "https://gateway.pinata.cloud/ipfs/".concat(cidv1).concat(path);
        case Node.IPFS:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
        case Node.DWEB:
            return "https://".concat(cidv1, ".ipfs.dweb.link").concat(path);
        case Node.VERSUM:
            return "https://ipfs.versum.cloud/ipfs/".concat(cidv1).concat(path);
        default:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
    }
};
// converts ipfs:// if match or returns https://
var getURLFromIPFSorHTTP = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", node = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.INFURA;
    if (value && value.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(value, node);
    }
    return value;
};


/***/ }),

/***/ 56373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ getViewerEditionsOutsideMarket; },
/* harmony export */   "Id": function() { return /* binding */ extractMedium; },
/* harmony export */   "KE": function() { return /* binding */ getVideoSubtitles; },
/* harmony export */   "NJ": function() { return /* binding */ getTags; },
/* harmony export */   "P$": function() { return /* binding */ getResponsiveVideos; },
/* harmony export */   "_U": function() { return /* binding */ getSmallestImageBoardPreview; },
/* harmony export */   "hD": function() { return /* binding */ getWebDimensions; },
/* harmony export */   "j8": function() { return /* binding */ getArtifactUri; },
/* harmony export */   "t_": function() { return /* binding */ getDimensions; },
/* harmony export */   "to": function() { return /* binding */ getResponsiveCover; },
/* harmony export */   "vy": function() { return /* binding */ getResponsiveImages; },
/* harmony export */   "yb": function() { return /* binding */ getVideoPoster; }
/* harmony export */ });
/* unused harmony exports getRandomIPFSNode, getSrcSet, getViewerEditionsOnSwap, getViewerEditionsOnAuction */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _lib_media_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46493);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6767);
/* harmony import */ var _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80125);

/* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 



var getTags = function(tags) {
    return tags.map(function(e) {
        return e.tag.name;
    });
};
// defines a max of images on the srcset on feeds
// 1 would generate the 480px image
// 2 would generate the 480px + 960px image
var FEED_MAX_IMAGE_PREVIEW = 2; // min value is 1, recommended value is 2
var getRandomIPFSNode = function() {
    var options = [
        Node.INFURA,
        Node.IPFS /* , Node.VERSUM */ 
    ];
    var index = Math.floor(Math.random() * options.length);
    return options[index];
};
var getWebDimensions = function(formats, platform) {
    if (platform.name === _constants__WEBPACK_IMPORTED_MODULE_0__/* .Platforms.VERSUM */ .YK.VERSUM) {
        if (formats.length) {
            var ref;
            var og = (ref = formats[0]) === null || ref === void 0 ? void 0 : ref.dimensions;
            if ((og === null || og === void 0 ? void 0 : og.unit) === "ratio") {
                var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(og.value.split(":"), 2), width = ref1[0], height = ref1[1];
                var a = parseFloat(width) / parseFloat(height);
                return {
                    width: a * 100000,
                    height: 100000
                };
            }
            if ((og === null || og === void 0 ? void 0 : og.unit) === "px") {
                var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(og.value.split("x"), 2), width1 = ref2[0], height1 = ref2[1];
                return {
                    width: parseFloat(width1),
                    height: parseFloat(height1)
                };
            }
        }
        return null;
    }
    return {
        width: 960,
        height: 960
    };
};
var getDimensions = function(formats) {
    // some previews are smaller than the biggest dimension available.
    var preview = formats.filter(function(e) {
        return e.mimeType.includes("image");
    });
    // if there are no preview metada, try checking for the original asset
    if (preview.length === 0) {
        preview = formats;
    }
    var dimensions = preview.filter(function(e) {
        return e.dimensions;
    }).map(function(e) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.dimensions.value.split("x"), 2), width = ref[0], height = ref[1];
        return {
            width: parseFloat(width),
            height: parseFloat(height)
        };
    }).sort(function(a, b) {
        return b.width - a.width;
    });
    // if there is a "dimensions array"
    if (dimensions.length > 0) {
        return dimensions;
    }
    // if no "dimensions array", return default settings
    return [
        {
            width: 960,
            height: 960
        }
    ];
};
var getSrcSet = function(formats) {
    var inDetailView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, limitToMax = arguments.length > 2 ? arguments[2] : void 0;
    // get all images on formats (including the original) // changing to excluding the original
    var images = formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }) // includes original (gifs)
    .sort(function(a, b) {
        return a.dimensions.value.split("x")[0] - b.dimensions.value.split("x")[0]; // order from smallest to largest
    }).filter(function(_data, index) {
        // on feed dont show all resolutions
        if (!inDetailView && index > FEED_MAX_IMAGE_PREVIEW - 1) {
            return false;
        }
        if (limitToMax && index > limitToMax) {
            return false;
        }
        // in detail view show all resolutions
        return true;
    }).sort(function(a, b) {
        return b.dimensions.value.split("x")[0] - a.dimensions.value.split("x")[0]; // order from largest to smallest
    });
    // extract all dimensions and order them by largest to smaller
    var dimensions = images.map(function(e) {
        return e.dimensions.value.split("x")[0];
    }).sort(function(a, b) {
        return b - a;
    });
    // sorting order needs to be smaller to largest
    var node = inDetailView ? _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .Node.INFURA */ .NB.INFURA : undefined;
    return images.map(function(e, i) {
        var src = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, node);
        return "".concat(src, " ").concat(dimensions[i], "w");
    }).join(", ");
};
// was INFURA
var getArtifactUri = function(token, nodeType) {
    var src = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(token.artifact_uri, nodeType);
    var alt = token.title;
    var dimensions = getDimensions(token.formats);
    var ref = dimensions[0], width = ref.width, height = ref.height;
    return {
        src: src,
        width: width,
        height: height,
        alt: alt
    };
};
var getResponsiveImages = function(token) {
    var inDetailView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, limitToMax = arguments.length > 2 ? arguments[2] : void 0;
    var dimensions = getDimensions(token.formats).sort(function(param, param1) {
        var a = param.width, b = param1.width;
        return a - b;
    }) // order from smallest to largest
    .filter(function(_data, index) {
        // on feed view dont show the highest resolution images as they slow down page loading
        if (!inDetailView && index > FEED_MAX_IMAGE_PREVIEW - 1) {
            return false;
        }
        if (limitToMax && index > limitToMax) {
            return false;
        }
        // in detail view show all resolutions
        return true;
    });
    var width = dimensions[dimensions.length - 1].width;
    // we define the image max width to be the largest of the dimensions array width
    var sizes = "(max-width: ".concat(width, "px) 100vw, ").concat(width, "px");
    var srcset = getSrcSet(token.formats, inDetailView, limitToMax);
    if (sizes && srcset) {
        return {
            sizes: sizes,
            srcset: srcset
        };
    }
    return null;
};
var getResponsiveVideos = function(token, nodeType) {
    // get all preview videos
    var previews = token.formats.filter(function(e) {
        var ref;
        return ((ref = e.fileName) === null || ref === void 0 ? void 0 : ref.includes(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_FILENAME_PREFIX */ .Nq)) && e.mimeType === _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP4 */ .HY.MP4;
    }).sort(function(a, b) {
        return b - a;
    });
    if (previews.length > 0) {
        // return both versions, its up for the WrapperComponent (JSX) to decide which one to render
        return previews.map(function(e) {
            return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, nodeType);
        });
    }
    return null;
};
var getResponsiveCover = function(token) {
    // similar to responsive images, its used on any asset that renders an image but its artifactUri is not an image.
    // e.g.: audio/3d/pdf
    // since the artifact_uri on an audio track is an mp3 and the cover is on the formats
    // we need to handle the logic differently than we do with images (which is a combination of getArtifactUri and getResponsiveImages)
    var dimensions = getDimensions(token.formats);
    var width = dimensions[0].width;
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b - a;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri);
    });
    var src = previews[0];
    var sizes = "(max-width: ".concat(width, "px) 100vw, ").concat(width, "px");
    var srcset = getSrcSet(token.formats);
    if (src && sizes && srcset) {
        return {
            src: src,
            sizes: sizes,
            srcset: srcset
        };
    }
    return null;
};
var getVideoPoster = function(token) {
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b - a;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri);
    });
    return previews.length > 0 ? previews[0] : "";
};
var getVideoSubtitles = function(token) {
    // get all subtitlestou a comer das-m
    var subtitles = token.formats.filter(function(e) {
        var ref;
        return ((ref = e.fileName) === null || ref === void 0 ? void 0 : ref.includes(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_SUBTITLES_PREFIX */ .qI)) && e.mimeType === _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.VTT */ .HY.VTT;
    }).map(function(st) {
        // this function gets the subtitles fileName and generates a label and srcLang
        // because those are not TZIP21 spec
        var getPropsFromName = function(value) {
            var label = "English";
            var srcLang = "en";
            var tail = value.indexOf(".vtt");
            var key = String(value).slice(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_SUBTITLES_PREFIX.length */ .qI.length, tail);
            switch(key){
                case "de":
                    label = "German";
                    srcLang = key;
                    break;
                default:
                    label = "English";
                    srcLang = "en";
            }
            return {
                label: label,
                srcLang: srcLang
            };
        };
        var ref = getPropsFromName(st.fileName), label = ref.label, srcLang = ref.srcLang;
        var url = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(st.uri, _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .Node.CLOUDFLARE */ .NB.CLOUDFLARE);
        return {
            label: label,
            srcLang: srcLang,
            file: url
        };
    });
    if (subtitles) {
        return subtitles;
    }
    return undefined;
};
var getSmallestImageBoardPreview = function(token, node) {
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b.fileSize - a.fileSize;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, node);
    });
    var src = previews[previews.length - 1];
    if (src) {
        return {
            src: src
        };
    }
    return null;
};
// returns the amount of editions the user has in their collection
var getViewerEditionsOutsideMarket = function(viewer, holders) {
    return holders.reduce(function(a, c) {
        if (c.holder.user[0].user.id === viewer) {
            return a + c.amount;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on swaps
var getViewerEditionsOnSwap = function(viewer, swaps) {
    return swaps.reduce(function(a, c) {
        if (c.seller.user[0].user.id === viewer) {
            return a + c.amount_left;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on auctions
var getViewerEditionsOnAuction = function(viewer, auctions) {
    return auctions.reduce(function(a, c) {
        if (c.seller.user[0].user.id === viewer) {
            return a + 1;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on offers
// export const getViewerEditionsOnOffers = (viewer: string, offers: any[]) => {
//   return offers.reduce((a: any, c: any) => {
//     if (c.buyer.user[0].user.id === viewer) {
//       return a + 1;
//     }
//     return a;
//   }, 0);
// };
var extractMedium = function(token) {
    var original = token.formats[0];
    var extractDimensions = function(dimensions) {
        if (dimensions) {
            return " | ".concat(dimensions.value).concat(dimensions.unit);
        }
        return "";
    };
    var extractSize = function(size) {
        if (size) {
            return " | ".concat((0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatBytes */ .td)(size));
        }
        return "";
    };
    var extractDuration = function(duration) {
        if (duration) {
            return ", ".concat(duration.split(":").reduce(function(acc, time) {
                return 60 * acc + +time;
            }), " seconds"); // converts HH:MM:SS: to seconds
        }
        return "";
    };
    switch(token.mime){
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.GIF */ .HY.GIF:
            return original ? "GIF".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "GIF";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.JPEG */ .HY.JPEG:
            return original ? "JPG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "JPG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.PNG */ .HY.PNG:
            return original ? "PNG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "PNG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.SVG */ .HY.SVG:
            return original ? "SVG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "SVG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP4 */ .HY.MP4:
            return original ? "MP4".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "MP4";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.OGV */ .HY.OGV:
            return original ? "OGG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "OGG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.GLB */ .HY.GLB:
            return "GLB";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP3 */ .HY.MP3:
            return original ? "MP3".concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "MP3";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.WAV */ .HY.WAV:
            return original ? "WAV".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "WAV";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.WEB */ .HY.WEB:
            return original ? "WEB".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "WEB";
        default:
            return "Unknown";
    }
};


/***/ }),

/***/ 17874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mc": function() { return /* binding */ getTZIP21Dimensions; },
/* harmony export */   "RY": function() { return /* binding */ getTZIPFormat; },
/* harmony export */   "i0": function() { return /* binding */ getTZIP21WebFormat; }
/* harmony export */ });
/* unused harmony exports getTZIP21GenericFormat, getTZIP21ImageFormat, getTZIP21VideoFormat, getTZIP21AudioFormat */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6767);






var getTZIP21GenericFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, hash) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", {
                        uri: "ipfs://".concat(hash),
                        mimeType: file.type,
                        fileSize: file.size,
                        fileName: file.name
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIP21GenericFormat(file, hash) {
        return _ref.apply(this, arguments);
    };
}();
var getTZIP21ImageFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, hash, width, height) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", {
                        uri: "ipfs://".concat(hash),
                        mimeType: file.type,
                        fileSize: file.size,
                        fileName: file.name,
                        dimensions: {
                            value: "".concat(width, "x").concat(height),
                            unit: "px"
                        }
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIP21ImageFormat(file, hash, width, height) {
        return _ref.apply(this, arguments);
    };
}();
var getTZIP21VideoFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, hash, width, height, duration) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", {
                        uri: "ipfs://".concat(hash),
                        mimeType: file.type,
                        fileSize: file.size,
                        fileName: file.name,
                        dimensions: {
                            value: "".concat(width, "x").concat(height),
                            unit: "px"
                        },
                        duration: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .formatDuration */ .LU)(duration)
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIP21VideoFormat(file, hash, width, height, duration) {
        return _ref.apply(this, arguments);
    };
}();
var getTZIP21AudioFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, hash, duration) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", {
                        uri: "ipfs://".concat(hash),
                        mimeType: file.type,
                        fileSize: file.size,
                        fileName: file.name,
                        duration: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .formatDuration */ .LU)(duration)
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIP21AudioFormat(file, hash, duration) {
        return _ref.apply(this, arguments);
    };
}();
// get TZIP-21 format for any kind of file
var getTZIPFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, hash, meta) {
        var width, height, duration;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    width = meta.width || 0;
                    height = meta.height || 0;
                    duration = meta.duration || 0;
                    if (!_constants__WEBPACK_IMPORTED_MODULE_1__/* .IMAGE_MIMETYPES.includes */ .E0.includes(file.type)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", getTZIP21ImageFormat(file, hash, width, height));
                case 5:
                    if (!_constants__WEBPACK_IMPORTED_MODULE_1__/* .VIDEO_MIMETYPES.includes */ .ho.includes(file.type)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", getTZIP21VideoFormat(file, hash, width, height, duration));
                case 7:
                    if (!_constants__WEBPACK_IMPORTED_MODULE_1__/* .AUDIO_MIMETYPES.includes */ .yz.includes(file.type)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", getTZIP21AudioFormat(file, hash, duration));
                case 9:
                    return _ctx.abrupt("return", getTZIP21GenericFormat(file, hash));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIPFormat(file, hash, meta) {
        return _ref.apply(this, arguments);
    };
}();
var getTZIP21Dimensions = function(width, height, aspect) {
    if (aspect) {
        return {
            value: aspect,
            unit: "ratio"
        };
    }
    if (width && height) {
        return {
            value: "".concat(width, "x").concat(height),
            unit: "px"
        };
    }
    return {
        value: "100x100",
        unit: "pct"
    };
};
var getTZIP21WebFormat = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(hash, name, size, width, height, aspect) {
        var format, dimensions;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    format = {
                        uri: "ipfs://".concat(hash),
                        mimeType: _constants__WEBPACK_IMPORTED_MODULE_1__/* .MimeType.WEB */ .HY.WEB,
                        fileSize: size,
                        fileName: name
                    };
                    dimensions = getTZIP21Dimensions(width, height, aspect);
                    if (!dimensions) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, format), {
                        dimensions: dimensions
                    }));
                case 4:
                    return _ctx.abrupt("return", format);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTZIP21WebFormat(hash, name, size, width, height, aspect) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R1": function() { return /* binding */ removeDuplicates; },
/* harmony export */   "lm": function() { return /* binding */ sanitiseTags; }
/* harmony export */ });
/* unused harmony exports validateAddress, validateDomain */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _taquito_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4118);


var removeDuplicates = function(a) {
    var trim = Array.from(new Set(a), function(x) {
        return x.replace(/\s+/g, " ").trim();
    });
    return trim.reduce(function(unique, item) {
        return unique.includes(item) ? unique : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(unique).concat([
            item
        ]);
    }, []).filter(function(e) {
        return e !== "";
    });
};
// removes duplicates
var sanitiseTags = function(tags) {
    // substitute # for ,
    // removes space before and after ,
    // splitc by comma or hash
    return removeDuplicates(tags.replace(/#/g, ",").replace(/\s*,\s*/g, ",").split(/[#,]+/));
};
// validates tezos address
var validateAddress = function(address) {
    return taquitoValidateAddress(address);
};
// validates tezos domain
var validateDomain = function(domain) {
    // const regexp = new RegExp(/^[a-z]{2,51}\.tez$/);
    // reference https://gitlab.com/tezos-domains/client/-/blob/master/packages/core/src/validator/validators.ts
    var regexp = /^[a-z0-9-]{1,100}\.tez$/;
    return regexp.test(domain);
};


/***/ })

}]);